import { useSyncExternalStore } from "react";
import { bagCount, bagLabel } from "../../src/lib/shop-bag-items";
import { readBag } from "../../src/lib/shop-storage";

// The bag lives in this browser only (site/src/lib/shop-storage.ts). The header follows it as this
// tab or another one changes it.
function subscribe(update: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (!event.key || event.key.startsWith("drate-shop:")) update();
  };
  document.addEventListener("drate:bag", update);
  window.addEventListener("storage", onStorage);
  window.addEventListener("pageshow", update);
  return () => {
    document.removeEventListener("drate:bag", update);
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("pageshow", update);
  };
}

function useBagCount(creatorId: string) {
  return useSyncExternalStore(
    subscribe,
    () => bagCount(readBag(creatorId)),
    () => 0,
  );
}

/** The way to the bag from every page of a creator site with a shop. */
export function BagLink({
  creatorId,
  href,
  menu = false,
}: {
  creatorId: string;
  href: string;
  menu?: boolean;
}) {
  const count = useBagCount(creatorId);
  const text = count > 99 ? "99+" : String(count);
  if (menu)
    return (
      <a className="menu-bag" href={href} data-shop-bag={creatorId}>
        Bag
        <span data-shop-bag-count hidden={!count}>
          {count ? text : null}
        </span>
      </a>
    );
  return (
    <a
      className="header-bag"
      href={href}
      data-shop-bag={creatorId}
      data-empty={count ? undefined : ""}
      aria-label={bagLabel(count)}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5.5 8.5h13l1 11.5h-15l1-11.5Z" />
        <path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" />
      </svg>
      <span className="header-bag-count" data-shop-bag-count hidden={!count}>
        {count ? text : null}
      </span>
    </a>
  );
}
